import { Icon, TextField, Tooltip } from "@shopify/polaris";
import styles from "./CustomInputWithUnit.module.css";
import { InfoIcon } from "@shopify/polaris-icons";

type Props_CustomInputWithUnit = {
    label?: string;
    setValue: (val: string) => void;
    value: string | number | undefined;
    unitSuffix?: string;
    placeholder?: string;
    helpText?: string;
    toolTip?: string;
    error?: string;
    props: any;
    min?: number;
};

const CustomInputWithUnit = ({
    label = "Label",
    setValue,
    value = 12,
    unitSuffix = "",
    placeholder = "",
    helpText = "",
    toolTip = "",
    error = "",
    props = {},
    min = 1,
}: Props_CustomInputWithUnit) => {
    // Display value without leading zeros
    const displayValue = value !== undefined && value !== null ? value.toString().replace(/^0+(?=\d)/, "") : "";

    return (
        <TextField
            min={min}
            label={
                <div className={styles.labelWithIcon}>
                    {label}
                    {toolTip && (
                        <div className={styles.customTooltip}>
                            <Tooltip width="wide" content={toolTip}>
                                <Icon source={InfoIcon} tone="subdued" />
                            </Tooltip>
                        </div>
                    )}
                </div>
            }
            placeholder={placeholder}
            helpText={helpText}
            error={error}
            {...props}
            value={displayValue || "0"}
            onChange={(e) => {
                const numericValue = Math.abs(+e) || 0;
                setValue(numericValue.toString());
            }}
            autoComplete="off"
            suffix={unitSuffix.length ? <div className={styles.unitSuffix}>{unitSuffix}</div> : false}
            type={"number"}
        />
    );
};

export default CustomInputWithUnit;
